import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import './storyListingFooter.scss';
import './storyListingTable.scss';
import './storyListingCheckboxDropdown.scss';
import Footer from '../Footer/footer';
import Header from '../Header/header';
import getRawStories from '../../services/storyListing';
import Listing from '../Listing/listing';
import addPurchaseStory from '../../services/purchase/addPurchaseStory';
import addStory from '../../services/addStory';
import addCover from '../../services/addCover';
// import getCompanies from '../../services/getCompanyList';
import { auth as AuthObject } from '../../services/login'
import '../Header/header.scss';
import cookie from '../../cookieHelper/cookie';
import { jsonToString, filterWarnings } from 'webpack/lib/Stats';
import toastNotify from '../../utils/toastNotifier';
import { validateLinkUrl } from '../../utils/validate';

import bulkStoryPublishDraft from '../../services/story/bulkStoryPublishDraft';

import PopulateCompanyList from '../CompanyList/companyList';
import getCompanies from '../../services/getCompanyList';

import { LinkTypes, LinkTypesMapper } from '../../constants/constant';

import EmptyScreen from '../../components/EmptyScreen/EmptyScreen';
import withRouter from '../withRouter';

class StoryListing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            storyType: '',
            s3Path: '',
            rowIndex: '',
            publishOn: '',
            companyID: '',
            storeDropContent: '',
            companies: [],
            linkUrl: '',
            linkType: 0,
            coverObj: '',
            coverArr: {},
            publishType: '',
            tokenCheck:true
        }
        // var elem=document.getElementById("is");
        // elem.classList.add("active");

        // this.companyList();
        this.checkAuth();

        this.multiData = [];
        this.bulkPublishData = [];
        this.bulkDraftData = [];
        this.multiSelectPublishOn;
        this.multiSelectCompanyID

        this.multipleCheckboxes;
    }

    checkAuth = () => {
        AuthObject.authenticate(() => {
            if (cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)) {
                console.log("cookie found");

                this.setState(() => ({
                    redirectToReferrer: true
                }))
            }
        })
    }

    componentDidMount() {
        this.rawStories();
        // this.loginProfileInfo = JSON.parse(localStorage.getItem('loginProfileInfo'));
        // this.createdBy = this.loginProfileInfo.id;

        this.loginProfileInfo = JSON.parse(cookie.getCookie('loginProfileInfo'));
        this.createdBy = this.loginProfileInfo.id;

        console.log("CREATED BY IS: ", this.loginProfileInfo.id);
        if (this.props.purchaseContext) return;
        let list = {};

        const companyList = async () => {
            let companiesResult = await getCompanies();

            if (!(companiesResult instanceof Error)) {
                if (companiesResult.status.code == "10200") {
                    list = companiesResult.data[0];

                    console.log("companyList: ", list);
                    this.getList = list;
                    // console.log(list.companies.length);
                    // let companyListing = <option>No company Found</option>;
                    // var companyListing = document.createElement('select');
                    if (typeof list === 'undefined') {
                        // console.log("if ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                    else if (Object.keys(list).length === 0) {
                        // console.log("else if-1 ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                    else if (list.companies.length) {
                        // console.log("else if-2 ran");
                        let teamsFromApi = list.companies.map(item => { return { value: item.id, display: item.companyName } })
                        this.setState({ companies: [{ value: '', display: 'Select Company' }].concat(teamsFromApi) });
                    }
                    else {
                        // console.log("else ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                } else {
                    toastNotify("3", "Some error occured while fetching companies list")
                }
            } else {
                const response = JSON.parse(companiesResult.request.response);
                const code = response?.status?.code;
                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokenCheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }
                else{
                    toastNotify("3", "Some error occured while fetching companies list")

                }
            }
        }

        companyList();

        // this.createdBy = '5c9b15d0f6f4892d78599385';
    }

    redirectHandler = () => {
        this.setState({
            redirectToStoryList: true
        })

    }

    redirectHandlerAllStory = () => {
        // console.log("in redirectHandler");  
        this.setState({
            redirectToAllStory: true
        })
    }

    eventHandleClick() {
        // var ui = document.querySelector(".profile-menu");
        // var conui=document.querySelector(".container");

        var ui = document.querySelector(".profile-menu");
        if (ui) ui.style.display = "none";
    }

    rawStories = async () => {
        let value = await getRawStories();



        if (!(value instanceof Error)) {
            if (value.status.code == "10200") {
                if (value.data.length) {
                    let rows = value.data.map((item, index) => {
                        return {
                            storyType: item.fileType,
                            s3Path: item.s3Path.split("raw/")[1],
                            rowIndex: index,
                            publishOn: this.props.purchaseContext?.origin || '',
                            companyID: this.props.purchaseContext?.centralCompanyId || '',
                            expiry: '',
                            createdOn: '',
                            publishType: '',
                        }
                    })

                    this.setState({
                        rawStories: value.data,
                        rows: rows
                    })
                } else {
                    this.setState({
                        rawStories: [],
                        rows: []
                    })
                }
            }

        } else {
            // Handle error

            const response = JSON.parse(value.request.response);
            const code = response?.status?.code;
            if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                this.setState({ tokenCheck: false });
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
            }
            else{

                toastNotify(3, "Some error occured. Please try again later.")
            }



        }
    }
    logoValidation = (index) => {
        var formData = new FormData();

        var file = document.getElementById("myfile_" + index).files[0];

        if (file) {
            formData.append("Filedata", file);
            // var t = file.type.split('/').pop().toLowerCase();
            if (file.size == 0) {
                toastNotify(3, 'Please select banner image');
                return false;
            }
            else if (file.size > 200000) {
                // alert('Max Upload size is 200KB only');
                toastNotify(3, 'Maximum upload size is 200KB only');
                this.setState({
                    coverObj: ''
                })
                document.getElementById("myfile_" + index).value = '';
                return false;
            }
            else {
                console.log("It can be uploaded");
                return true;
            }

        }
        else {
            // alert('No image Selected');
            toastNotify(3, 'Please select banner image');
            return false;
        }
    }
    setCover = async (e, rowIndex) => {
        var form = new FormData();
        form.append('cover', document.getElementById("myfile_" + rowIndex).files[0]);

        var val = document.getElementById("myfile_" + rowIndex).files[0];

        let result = await addCover(form);
        // coverArr[rowIndex] = result.data;
        let arr = [];
        arr[rowIndex] = result.data;
        this.setState({
            coverObj: result.data,
            coverArr:{...this.state.coverArr,...arr}


        })
        console.log('this.state.coverArr: ',this.state.coverArr);

    }

    onSubmit = async (e, rowIndex, fileType) => {
        e.preventDefault();
        let data = {};
        // if (fileType == 2) {
        let form = '';
        let val = '';


        if (fileType == 2) {
            form = new FormData();
            val = document.getElementById("myfile_" + rowIndex).files[0];
            form.append('cover', document.getElementById("myfile_" + rowIndex).files[0]);
        }
        if (fileType == 2) {
            data = {
                companyId: this.state.rows[rowIndex]['companyID'],
                publishOn: this.state.rows[rowIndex]['publishOn'],
                publishType: this.state.rows[rowIndex]['publishType'],
                storyType: this.state.rows[rowIndex]['storyType'],
                s3Path: this.state.rows[rowIndex]['s3Path'],
                createdBy: this.createdBy,
                bannerUrl: this.state.coverArr[rowIndex]?.coverRelativePath
            }
        }
        else {
            data = {
                companyId: this.state.rows[rowIndex]['companyID'],
                publishOn: this.state.rows[rowIndex]['publishOn'],
                publishType: this.state.rows[rowIndex]['publishType'] || 1,
                storyType: this.state.rows[rowIndex]['storyType'],
                s3Path: this.state.rows[rowIndex]['s3Path'],
                createdBy: this.createdBy
            }
        }

        if (typeof this.state.rows[rowIndex]['linkUrl'] != 'undefined' && this.state.rows[rowIndex]['linkUrl'].length) {
            data['linkUrl'] = this.state.rows[rowIndex]['linkUrl']
        }

        if (typeof this.state.rows[rowIndex]['linkType'] != 'undefined' && this.state.rows[rowIndex]['linkType']) {
            data['linkType'] = parseInt(this.state.rows[rowIndex]['linkType']);
        }

        if (typeof this.state.rows[rowIndex]['linkText'] != 'undefined' && this.state.rows[rowIndex]['linkText'].length) {
            data['linkText'] = this.state.rows[rowIndex]['linkText'];
        }
        console.log('data: ', data);


        const { linkUrl = '', linkType, linkText = '' } = data;

        const isValidUrl = /^(https?:\/\/)?(www\.)?[\w.-]+\.[a-z]{2,}(\/\S*)?$/i.test(linkUrl);

        const externalDomainRegex = /(?:iimjobs\.com|hirist\.com|hirist\.tech)/i;
    
        if (linkUrl && !isValidUrl) {
            toastNotify(3, "Please enter a valid URL");
            return;
        }
    
        if (linkUrl && !linkText.length) {
            toastNotify(3, "Please add ‘Swipe Up Text’ to proceed");
            return;
        }


        if ( linkText && linkText.length > 60) {
            toastNotify(3, "Swipe Up Text should be less than 60 characters");
            return;
        }

        const publishOn = data.publishOn || '';
        
    
        const validation = validateLinkUrl(linkUrl, linkType,publishOn);
        
        if (validation.defaultUrl) {
            // Set default URL for recruiter profile
            data.linkUrl = validation.defaultUrl;
            console.log("Setting default URL for recruiter profile");
        } else if (!validation.isValid) {
            // Handle other invalid cases
            console.log("Invalid URL", validation.message);
            toastNotify(3, validation.message);
            return;
        }
      
    


        var ans = true;
        if (fileType == 2) {
            var ans = this.logoValidation(rowIndex);
        }

        if (ans == true) {
            this.validateData(data, e)
        }
    }

    validateData = async (data, e) => {
        e.persist();
        if (this.props.purchaseContext && this.addingPurchaseStory) return;
        if (data.companyId == "" || data.publishOn == "" || data.storyType == "" || data.s3Path == "" || data.createdBy == "" || data.publishType == "") {
            // alert("Please fill all the information of the story");
            toastNotify(3, "Please fill all the information of the story");
        }  else if ((data.linkUrl && !data.linkType) || (!data.linkUrl && data.linkType && data.linkType !== 3)) {
            toastNotify(3, "Please fill both Link type and Link Url or none");
        }
        else {
            try {
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }

                let result;
                if (this.props.purchaseContext) {
                    this.addingPurchaseStory = true;
                    const { companyId, ...fields } = data;
                    result = await addPurchaseStory({ ...fields, purchaseId: this.props.purchaseContext._id, publishOn: this.props.purchaseContext.origin });
                } else {
                    result = await addStory(data);
                }
                console.log('result:',result);
                if (result.status.code == 10200) {
                    e.target.parentElement.parentElement.classList.add("hidden");
                    toastNotify(1, "Successfully added story");
                }
                else {
                    const response = JSON.parse(result.request.response);
                    const code = response?.status?.code;
                    if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                        this.setState({ tokenCheck: false });
                        cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                        cookie.delete_cookie('loginProfileInfo');
                        AuthObject.isAuthenticated = false;
                    }
                    else {
                        toastNotify(3, "Some error occured. Please try again later.")
                    }


                }
            }
            catch (err) {
                console.log(err);
                const code = String(err.response?.data?.status?.code);
                if (this.props.purchaseContext && (err.response?.status === 401 || ['10411', '10412', '10416', '10417'].includes(code))) {
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                    this.setState({ tokenCheck: false });
                } else {
                    toastNotify(3, this.props.purchaseContext ? err.message || 'Unable to add story.' : "Image cannot be greater than 200KB and video Cannot be greater than 8MB");
                }
            } finally {
                this.addingPurchaseStory = false;
            }
        }
    }

    setCompanyID = (e, id) => {
        const row = {
            ...this.state.rows[id]
        }

        row.companyID = e.target.value;

        const rows = [...this.state.rows];
        rows[id] = row;

        this.setState({
            rows: rows
        })
    }

    setLinkType = (e, id) => {
        const linkType = parseInt(e.target.value, 10);
        const row = {
            ...this.state.rows[id]
        }

        // Default URLs based on portal
        const defaultUrls = {
            iimjobs: 'https://www.iimjobs.com/registration/addAudioVideoProfile',
            hirist: 'https://www.hirist.tech/registration/addAudioVideoProfile'
        };

        // Get the publishOn value for the current row
        const publishOn = row.publishOn || '';
        // Check if publishOn is a string (from direct selection) or an array (from bulk selection)
        const portal = Array.isArray(publishOn) 
            ? (publishOn[0] || 'iimjobs')
            : (publishOn || 'iimjobs');

        // If recruiter profile is selected (type 3), set the default URL
        if (linkType === 3) {
            // Use the portal directly as it's already the correct value
            row.linkUrl = defaultUrls[portal] || defaultUrls.iimjobs;
        }
        
        row.linkType = linkType;

        const rows = [...this.state.rows];
        rows[id] = row;

        this.setState({
            rows: rows
        })
    }

    setLinkUrl = (e, id) => {
        const row = {
            ...this.state.rows[id]
        }

        row.linkUrl = e.target.value;

        const rows = [...this.state.rows];
        rows[id] = row;

        this.setState({
            rows: rows
        })
    }

    setLinkText = (e, id) => {
        const row = {
            ...this.state.rows[id]
        }

        row.linkText = e.target.value;

        const rows = [...this.state.rows];
        rows[id] = row;

        this.setState({
            rows: rows
        })
    }

    setPublishOn = (e, id) => {
        var checkboxes = document.getElementsByName(id + '_origin');

        var vals = "";
        for (var i = 0, n = checkboxes.length; i < n; i++) {
            if (checkboxes[i].checked) {
                vals += "," + checkboxes[i].value;
            }
        }
        if (vals) vals = vals.substring(1);

        const row = {
            ...this.state.rows[id]
        }

        row.publishOn = vals.replace(/\s+/g, "");

        const rows = [...this.state.rows];
        rows[id] = row;

        this.setState({
            rows: rows
        })
    }

    setPostType = (e, id) => {
        let checkboxes = document.getElementsByName(id + '_storyType');
        let vals = "";
        for(let i = 0; i< checkboxes.length; i++){
            if(checkboxes[i].checked){
                vals += "," + checkboxes[i].value;
            }
        }
        if(vals){
            vals = vals.substring(1);
        }

        const row = {
            ...this.state.rows[id]
        }

        row.publishType = parseInt(vals.replace(/\s+/g, ""), 10);

        const rows = [...this.state.rows];
        rows[id] = row;

        this.setState({
            rows: rows
        })  
    }

    setExpiryDate = (e, id) => {
        const row = {
            ...this.state.rows[id]
        }

        row.expiryDate = e.target.value.replace(/T/g, " ").concat(":00.000Z");

        const rows = [...this.state.rows];
        rows[id] = row;

        this.setState({
            rows: rows
        })
    }

    selectMultipleStory = (e, index) => {
        var multiSelectMenu = document.querySelector(".multiSelectMenu");

        this.multipleCheckboxes = document.querySelectorAll(".multipleStory");

        this.multiData = [];
        for (var i = 0, n = this.multipleCheckboxes.length; i < n; i++) {
            var platformCheckboxes = document.getElementsByName(index + '_origin');

            if (this.multipleCheckboxes[i].checked) {
                let storyType = this.multipleCheckboxes[i].closest("tr").getAttribute("storytype");

                if (storyType == 1) {
                    this.multiData.push({
                        storyType: storyType,
                        s3Path: this.multipleCheckboxes[i].closest("tr").querySelector("img").getAttribute("src").split("/raw/")[1]
                    })
                }
                else if (storyType == 2) {
                    this.multiData.push({
                        storyType: storyType,
                        s3Path: this.multipleCheckboxes[i].closest("tr").querySelector("source").getAttribute("src").split("/raw/")[1]
                    })
                }

                // DISABLED ALL OTHER OPTIONS IN SELECTED ROW

                var selectDropdowns = this.multipleCheckboxes[i].closest("tr").querySelectorAll("select");
                this.multipleCheckboxes[i].closest("tr").querySelector("button").disabled = true;

                this.multipleCheckboxes[i].closest("tr").querySelector("input[name='linkUrl']").disabled = true;
                var platformRadioboxes = this.multipleCheckboxes[i].closest("tr").querySelectorAll("input[type=radio]");

                for (var key of selectDropdowns) {
                    key.disabled = true;
                }

                for (var key of platformRadioboxes) {
                    if(key.value !== "1" && key.value !== "2")
                        key.disabled = true;
                }


                this.multipleCheckboxes[i].closest("tr").querySelector("button").classList.add("disabled")
            }
            else {

                // ENABLE ALL OTHER OPTIONS IN SELECTED ROW

                var selectDropdowns = this.multipleCheckboxes[i].closest("tr").querySelectorAll("select");
                this.multipleCheckboxes[i].closest("tr").querySelector("button").disabled = false;

                this.multipleCheckboxes[i].closest("tr").querySelector("input[name='linkUrl']").disabled = false;
                var platformRadioboxes = this.multipleCheckboxes[i].closest("tr").querySelectorAll("input[type=radio]");

                for (var key of selectDropdowns) {
                    key.disabled = false;
                }

                for (var key of platformRadioboxes) {
                    key.disabled = false;
                }

                this.multipleCheckboxes[i].closest("tr").querySelector("button").classList.remove("disabled")
            }

        }

        if (this.multiData.length) {
            multiSelectMenu.classList.remove("hidden")
        }
        else {
            multiSelectMenu.classList.add("hidden")
        }
    }

    setMultiselectPublishOn = (e) => {
        var multiSelectPublishOnCheckboxes = document.getElementsByName("multiselect_origin");

        var vals = "";
        for (var i = 0, n = multiSelectPublishOnCheckboxes.length; i < n; i++) {
            if (multiSelectPublishOnCheckboxes[i].checked) {
                vals += "," + multiSelectPublishOnCheckboxes[i].value;
            }
        }
        if (vals) vals = vals.substring(1);

        this.multiSelectPublishOn = vals.replace(/\s+/g, "");


    }

    setMultiselectCompanyID = (e) => {
        this.multiSelectCompanyID = e.target.value;
    }



    bulkPublish = async () => {

        if (!this.multiSelectCompanyID) {
            alert("Please select a company")
        }
        else if (!this.multiSelectPublishOn) {
            alert("Please select a platform")
        }
        else {
            this.bulkPublishData = [];
            this.multiData.forEach((item, index) => {
                let object = {
                    ...item,
                    companyId: this.multiSelectCompanyID,
                    publishOn: this.multiSelectPublishOn,
                    createdBy: this.createdBy,
                    status: 1
                }

                this.bulkPublishData.push(object)
            });


            try {
                let result = await bulkStoryPublishDraft(this.bulkPublishData);

                if (result.status.code == 10200) {
                    for (var i = 0, n = this.multipleCheckboxes.length; i < n; i++) {
                        if (this.multipleCheckboxes[i].checked) {
                            this.multipleCheckboxes[i].checked = false;
                            this.multipleCheckboxes[i].closest("tr").classList.add("hidden")
                        }
                    }
                    toastNotify(1, "Successfully added stories");
                }

            }
            catch (err) {
                console.log(err);
                toastNotify(3, "Stories couldn't be added. Please try later");
            }
        }
    }

    bulkDraft = async () => {

        if (!this.multiSelectCompanyID) {
            alert("Please select a company")
        }
        else if (!this.multiSelectPublishOn) {
            alert("Please select a platform")
        }
        else {
            this.bulkDraftData = [];
            this.multiData.forEach((item, index) => {
                let object = {
                    ...item,
                    companyId: this.multiSelectCompanyID,
                    publishOn: this.multiSelectPublishOn,
                    createdBy: this.createdBy,
                    status: 3
                }

                this.bulkDraftData.push(object)
            });

            // console.log("this.bulkDraftData : ", this.bulkDraftData);

            try {
                let result = await bulkStoryPublishDraft(this.bulkDraftData);
                // console.log("resut of bulk draft: ",result);

                if (result.status.code == 10200) {
                    for (var i = 0, n = this.multipleCheckboxes.length; i < n; i++) {
                        if (this.multipleCheckboxes[i].checked) {
                            this.multipleCheckboxes[i].checked = false;
                            this.multipleCheckboxes[i].closest("tr").classList.add("hidden")
                        }
                    }
                    toastNotify(1, "Successfully added stories to draft");
                }
            }
            catch (err) {
                console.log(err);
                toastNotify(3, "Stories couldn't be added to draft. Please try later");
            }
        }
    }

    render() {
        const purchase = this.props.purchaseContext;

        if (!this.state.tokenCheck) {
            return <Navigate to={'/'} />
        }


        let toShowAddPostOption = false;

        if (this.state.redirectToStoryList) {
            return <Navigate to={purchase ? `/companies/${purchase.centralCompanyId}/purchases/${purchase._id}/stories` : '/Story'} />
        }
        else if (this.state.redirectToAllStory) {
            return <Navigate to={'/allStories'} />
        }

        let rows;
        let emptyScreen = null;
        if(this.state.rawStories){
            toShowAddPostOption = this.state.rawStories.findIndex(x => x.fileType == 2) !== -1
        }

        if (this.state.rawStories && this.state.rawStories.length) {
            rows = (
                this.state.rawStories.map((item, index) => {
                    let videoClassName, imageClassName, storytype;
                    if (item.fileType == 1) {
                        videoClassName = "videoComponent hidden";
                        imageClassName = "imageComponent";
                        storytype = 1;
                    }
                    else if (item.fileType == 2) {
                        videoClassName = "videoComponent";
                        imageClassName = "imageComponent hidden";
                        storytype = 2;
                    }

                    return (
                        <tr key={index} rowindex={index} storytype={storytype}>
                            {!purchase && <td>
                                <div className="story-select"
                                    onChange={(e) => this.selectMultipleStory(e, index)}
                                >
                                    <div className="checkbox small">
                                        <label>
                                            <input type="checkbox" name="multipleStory" className="multipleStory" />
                                        </label>
                                    </div>
                                </div>
                            </td>}
                            <td>
                                <div className={videoClassName}>
                                    <video width="200" height="200" controls loop>
                                        <source src={item.s3Path} type="video/mp4" />
                                    </video>
                                </div>
                                <div className={imageClassName}>
                                    <img src={item.s3Path} />
                                </div>

                            </td>
                            <td>
                                {purchase ? <input aria-label="Company" value={purchase.companyName} readOnly /> : <select onChange={(e) => this.setCompanyID(e, index)}>
                                    {this.state.companies.map((item) => <option key={item.value} value={item.value}>{item.display}</option>)}
                                </select>}

                            </td>

                            <td>
                                {purchase ? <input aria-label="Platform" value={purchase.origin} readOnly /> : <div id="checkboxes" onChange={(e) => this.setPublishOn(e, index)}>
                                    <label>
                                        <input type="radio" name={index + "_origin"} id="1" value="iimjobs" />
                                        iimjobs
                                    </label>
                                    <label>
                                        <input type="radio" name={index + "_origin"} id="2" value="hirist" />
                                        hirist
                                    </label>
                                </div>}
                            </td>

                            {toShowAddPostOption && (
                                <td>
                                    <div id="checkboxes" className={videoClassName} onChange={(e) => this.setPostType(e, index)}>
                                        <label>
                                            <input type="radio" name={index + "_storyType"} id="1" value="1" />
                                            story
                                        </label>
                                        <label>
                                            <input type="radio" name={index + "_storyType"} id="2" value="2" />
                                            reel
                                        </label>
                                    </div>
                                </td>
                            )}

                            <td>
                                <select onChange={(e) => this.setLinkType(e, index)}>
                                    <option value="">Select Link Type</option>
                                    {Object.keys(LinkTypesMapper).map((key) => <option key={key} value={key}>{LinkTypesMapper[key]}</option>)}
                                </select>
                            </td>

                            <td>
                                <input 
                                    type="text" 
                                    name="linkUrl" 
                                    value={this.state.rows[index].linkUrl || ''} 
                                    onChange={(e) => this.setLinkUrl(e, index)}
                                />
                            </td>

                            <td>
                                <input type="text" name="linkText" onChange={(e) => this.setLinkText(e, index)}></input>
                            </td>
                            <td>
                                {item.fileType == 2 ?
                                    <div>
                                        <input type="file" onChange={(e) => this.setCover(e, index)} id={`myfile_${index}`} name="myfile" className="color_green" accept=".jpg, .jpeg, .JPG, .JPEG"></input>
                                        <p>Image size should not greater than 200Kb</p>
                                    </div>

                                    : ""}

                            </td>

                            <td>
                                <button className={`${item.fileType == 2 && !this.state.coverArr[index]?.coverRelativePath ? "disabled" : ""} color_green btn-default`} onClick={(e) => this.onSubmit(e, index, item.fileType)} disabled={item.fileType == 2 && !this.state.coverArr[index]?.coverRelativePath ? true : false}>
                                    Add
                                </button>
                            </td>


                        </tr>
                    )
                })
            )
        } else {
            emptyScreen = (
                <EmptyScreen item="Raw Stories" />
            )
        }

        return (
            <div className="bodyWrapper" onClick={this.eventHandleClick}>
                <Header />
                <section className="listing_header">

                    <div className="wrapper">
                        <div className="wrapperButton" onClick={this.redirectHandler}>
                            &lt; Back To Story Listing
                        </div>
                        {!purchase && <div className="wrapperButton" onClick={this.redirectHandlerAllStory}>
                            All Company Stories
                        </div>}

                        <h1>Add New Story</h1>
                        {purchase && <p>Purchase: {purchase.quotelineNo || purchase._id} · <Link to={`/companies/${purchase.centralCompanyId}/purchases`}>Back to purchases</Link></p>}

                        {!purchase && <div className="multiSelectMenu hidden">
                            <h3>Bulk select menu</h3>

                            <select name="company" className="menuItem" onChange={(e) => this.setMultiselectCompanyID(e)}>
                                <option value="">Select Company</option>
                                {this.state.companies.map((item) => <option key={item.value} value={item.value}>{item.display}</option>)}
                            </select>
                            <div id="checkboxes" className="menuItem" onChange={this.setMultiselectPublishOn}>
                                <label>
                                    <input type="radio" name="multiselect_origin" id="1" value="iimjobs" />
                                    iimjobs
                                </label>
                                <label>
                                    <input type="radio" name="multiselect_origin" id="2" value="hirist" />
                                    hirist
                                </label>

                            </div>
                            <button className="menuItem btn-default" onClick={this.bulkPublish}>Bulk Publish</button>
                            <button className="menuItem btn-default" onClick={this.bulkDraft}>Bulk Save as Draft</button>
                        </div>}


                        <div className="wrapperTable">
                            <table border="1" className="mtb20 recruiter_listing" width="100%">
                                <tbody>
                                    <tr className="table-header">
                                        {!purchase && <th className="table_header">Select</th>}
                                        <th className="table_header">Media</th>
                                        <th className="table_header">Company</th>
                                        {/* <th className="table_header">Expiry</th> */}
                                        <th className="table_header">Platform</th>
                                        {toShowAddPostOption && (<th className="table_header">Post Type</th>)}
                                        <th className="table_header">Link Type</th>
                                        <th className="table_header">Link Url</th>
                                        <th className="table_header">Swipe Up Text</th>
                                        <th className="table_header ">Option</th>
                                        <th className="table_header ">Actions</th>

                                    </tr>
                                    {rows}
                                </tbody>
                            </table>
                            {emptyScreen}
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}

export default withRouter(StoryListing);    